import { SectionLabel } from "./WhatMakesSpecial";

const points = [
  {
    icon: "ri-shield-check-line",
    title: "Licensed by PAGCOR & Gaming Curacao",
    body: "Rolex9 operates under licences issued by PAGCOR (Philippines Amusement and Gaming Corporation) and Gaming Curacao — two of the most respected gaming regulators in the Asia-Pacific and international markets. Every game and transaction is conducted under strict regulatory oversight.",
  },
  {
    icon: "ri-verified-badge-line",
    title: "Certified Fair Play",
    body: "All games on Rolex9 are independently tested and certified for fairness. RNG systems are regularly audited by third-party labs including BMM Testlabs and TST Verified to guarantee unbiased outcomes on every spin and hand.",
  },
  {
    icon: "ri-lock-password-line",
    title: "SSL Encryption & ThreatMetrix",
    body: "Your data is protected by industry-standard SSL encryption. Rolex9 also uses ThreatMetrix fraud detection technology to monitor and prevent unauthorised access, keeping your account and funds secure at all times.",
  },
  {
    icon: "ri-bank-card-line",
    title: "Secure Australian Payments",
    body: "All payment methods — including PayID, OSKO, Visa, Mastercard, Apple Pay and Google Pay — are processed through secure, verified channels. Deposits and withdrawals are encrypted end-to-end.",
  },
  {
    icon: "ri-heart-pulse-line",
    title: "Responsible Gambling",
    body: "Rolex9 is committed to player wellbeing. The platform partners with eCOGRA, Gambling Therapy and Gambling Help Online. Deposit limits, session controls and self-exclusion tools are available to all players.",
  },
  {
    icon: "ri-eye-line",
    title: "Full Transparency",
    body: "Licence details, terms and conditions, and all security certifications are openly published. Rolex9 maintains complete transparency with its Australian player base — nothing is hidden.",
  },
];

export default function SecuritySection() {
  return (
    <section id="security" className="max-w-5xl mx-auto px-6 py-12">
      <SectionLabel>Security and Licence</SectionLabel>
      <p className="text-white/40 text-sm leading-relaxed mb-8 max-w-2xl">
        Play at Rolex9 with complete confidence. Licensed by PAGCOR and Gaming Curacao, certified by independent testing labs, every layer of the platform is built to protect Australian players — from your first deposit to your latest withdrawal.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-10">
        {points.map((p, i) => (
          <div
            key={i}
            className="glass-card rounded-2xl p-6 group hover:border-[#c9a84c]/20 transition-all duration-300"
            style={{ borderColor: "rgba(255,255,255,0.06)" }}
          >
            <div
              className="w-10 h-10 flex items-center justify-center rounded-xl mb-4"
              style={{ background: "linear-gradient(135deg, rgba(201,168,76,0.12), rgba(107,33,168,0.12))" }}
            >
              <i className={`${p.icon} text-[#c9a84c] text-lg`}></i>
            </div>
            <h3
              className="text-white/80 font-semibold text-sm mb-2"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              {p.title}
            </h3>
            <p className="text-white/35 text-xs leading-relaxed">{p.body}</p>
          </div>
        ))}
      </div>

    </section>
  );
}
